import type { TenantConfigListData } from "@scayla/api-client-fetch";
import { tenantConfigList, TenantConfigType } from "@scayla/api-client-fetch";
import { useQuery } from "@tanstack/vue-query";
import { computed } from "vue";

import { useWorkspace } from "@/store/workspace";

export function getProviderAccountQuery(providerId: string) {
  const workspace = useWorkspace();
  const tenantId = computed(() => workspace.tenantId);

  return {
    queryKey: ["tenantConfigList", tenantId.value, providerId],
    queryFn: async () => {
      const params = {
        path: { tenantId: tenantId.value! },
        query: { parentId: providerId, configType: TenantConfigType.MAILBOX_ACCOUNT },
      } as TenantConfigListData;
      const result = await tenantConfigList(params);
      if (result.error) {
        throw new Error(result.error.message);
      }

      return result.data;
    },
    enabled: computed(() => !!tenantId.value && !!providerId),
  };
}

export function getAccountsQuery(configType: string) {
  const workspace = useWorkspace();
  const tenantId = computed(() => workspace.tenantId);

  return {
    queryKey: ["tenantConfigList", tenantId.value, configType],
    queryFn: async () => {
      const params = {
        path: { tenantId: tenantId.value! },
        query: { configType: configType },
      } as TenantConfigListData;
      const result = await tenantConfigList(params);
      if (result.error) {
        throw new Error(result.error.message);
      }
      return result.data;
    },
    enabled: computed(() => !!tenantId.value && !!configType),
  };
}

export function useProviderAccount(providerId: string) {
  const queryConfig = getProviderAccountQuery(providerId);
  return useQuery({
    ...queryConfig,
    enabled: queryConfig.enabled.value,
  });
}
